import { Component } from '@angular/core';

@Component({
  selector: 'app-not-accredited-badge',
  template: ` <p
    class="px-3 py-1 text-xs font-medium text-center rounded text-background-800 bg-background-100"
  >
    Não credenciado
  </p>`,
  styleUrl: './not-accredited-badge.component.scss',
})
export class NotAccreditedBadgeComponent {}
